export default {"src":"/_next/static/media/half_star.53b3c969.svg","height":10,"width":11};